export default __webpack_public_path__ + "static/media/myslowickie-centrum-zdrowia.82ebd0bf.png";